/** How `downloadCsv` writes its cells. `formulasAsText`: a cell that
 * starts with `=`, `+`, `-`, `@`, a tab or a carriage return gets a
 * leading `'`, so that a spreadsheet opens it as text rather than as a
 * formula. Off for a file that is read back as a source, whose values
 * the prefix would change. */
export interface CsvOptions {
  formulasAsText?: boolean;
}

/** `value` as one CSV cell: empty for `null` and `undefined`, prefixed
 * as `options` asks, quoted when it holds a quote, a comma or a line
 * break. */
function csvCell(value: unknown, options: CsvOptions): string {
  let s = value === null || value === undefined ? '' : String(value);
  if (options.formulasAsText && /^[=+\-@\t\r]/.test(s)) {
    s = `'${s}`;
  }
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

/** Saves `rows`, one line each, as a CSV file named `fileName`. The file
 * starts with a byte-order mark so Excel opens Norwegian and Swedish
 * characters correctly. */
export function downloadCsv(fileName: string, rows: unknown[][], options: CsvOptions = {}): void {
  const lines = rows.map(row => row.map(value => csvCell(value, options)).join(','));
  saveBlob(new Blob(['﻿' + lines.join('\r\n')], {type: 'text/csv;charset=utf-8'}), fileName);
}

/** Saves `blob` as a file named `fileName`. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
